import { motion } from "framer-motion";

/** Numbered manifesto chapter header (00 → 12) */
export default function Chapter({ number, label, id }) {
  return (
    <div id={id} className="flex items-center gap-4 mb-8">
      <motion.span
        initial={{ opacity: 0, y: 4 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.3, ease: [0.22,1,0.36,1] }}
        className="font-mono text-[11px] text-ink-muted tracking-[0.28em]"
      >
        CH · {number}
      </motion.span>
      <motion.span
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.5, ease: [0.22,1,0.36,1], delay: 0.03 }}
        className="h-px w-14 origin-left"
        style={{ backgroundColor: "color-mix(in oklab, var(--text) 25%, transparent)" }}
      />
      <motion.span
        initial={{ opacity: 0, y: 4 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.3, delay: 0.05, ease: [0.22,1,0.36,1] }}
        className="font-mono text-[11px] text-ink-muted tracking-[0.22em] uppercase"
      >
        {label}
      </motion.span>
    </div>
  );
}
